import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactEditFormComponent } from './contact-edit-form.component';
import { CtFormModule, CtButtonModule } from '@ctsolution/ct-framework';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { FlexLayoutModule } from '@angular/flex-layout';

/**
 * Modulo per ContactEditFormComponent
 */
@NgModule({
  declarations: [ContactEditFormComponent],
  imports: [
    CommonModule,
    CtFormModule,
    CtButtonModule,
    MatCardModule,
    MatProgressSpinnerModule,
    FlexLayoutModule
  ],
  exports: [ContactEditFormComponent]
})
export class ContactEditFormModule {}
